import { type FC } from 'react'
import { JsonLd } from 'react-schemaorg'
import { type WebPage } from 'schema-dts'

import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { experimentAccessorIsMarketplace } from '../../../experiments/model/experimentAccessor'
import { useExperimentalAddStaticFileHost } from '../../../experiments/new-cdn-experiment/useExperimentalAddStaticFileHost'
import { useGlobalConfigContext } from '../../../global-config'
import { IMAGE_PRODUCT_FALLBACK_SRC } from '../../../image'
import { productPageGetJsonLdProductPageDescriptionSchema } from '../../seo/schemas/getProductDescriptionSchema'
import { useProductPageContext } from '../productPageContext'

const ProductPageJsonLdProductDescription: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { product, reviewData } = useProductPageContext()

  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  const { experiments } = useExperimentsContext()
  const isMarketplace = experimentAccessorIsMarketplace(experiments, tenant)
  const fallback = addStaticCdnHostToUrl(IMAGE_PRODUCT_FALLBACK_SRC)

  return (
    <JsonLd<WebPage>
      item={productPageGetJsonLdProductPageDescriptionSchema({
        fallback,
        isMarketplace,
        product,
        reviews: reviewData.productReviews.reviews,
      })}
    />
  )
}

export { ProductPageJsonLdProductDescription }
